export const CRYPTO_SCAM_DB_BASE_URL = 'https://api.cryptoscamdb.org/v1/';
